import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "MD Mart";
const DEFAULT_DESCRIPTION =
  "Shop groceries, daily essentials, offers, and household products online with MD Mart.";
const DEFAULT_IMAGE = "/assets/images/vendor-page/logo/mdmart.png";

const buildTitle = (title) =>
  title && title !== SITE_NAME ? `${title} | ${SITE_NAME}` : SITE_NAME;

export const SEO = ({
  title = SITE_NAME,
  description = DEFAULT_DESCRIPTION,
  canonical,
  image = DEFAULT_IMAGE,
  type = "website",
  jsonLd,
}) => {
  const pageTitle = buildTitle(title);

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
